<template>
  <div class="pre-alerts">
    <div class="e-form">
      <el-form inline ref="form" size="mini" class="flex-space">
        <div>
          <el-form-item label="">
            <el-button icon="el-icon-refresh" @click="loadData">
              Refresh
            </el-button>
            <el-popover placement="right" width="600" trigger="click">
              <div class="grid grid-cols-2 gap-2 p-1">
                <div>
                  <label>
                    Columns: drag&sort
                    <el-button type="text" @click="resetColumns"
                      >reset</el-button
                    >
                  </label>
                  <div class="max-h-[75vh] overflow-auto">
                    <draggable
                      v-model="columnOptions"
                      class="stripe"
                      draggable=".stripe-item"
                      ghost-class="ghost"
                      @change="moveColumn"
                    >
                      <div
                        v-for="column in columnOptions"
                        :key="column.name"
                        class="stripe-item"
                      >
                        <el-checkbox
                          v-model="column.visible"
                          :disabled="column.name == 'ID'"
                          @change="toggleColumn($event, column.name)"
                          >{{ column.name }}</el-checkbox
                        >
                      </div>
                    </draggable>
                  </div>
                </div>
                <div>
                  <label>Chart</label>
                  <el-radio-group
                    v-model="chartEnable"
                    size="mini"
                    @change="changeChartEnable"
                  >
                    <el-radio label="enable">Enable</el-radio>
                    <el-radio label="disable">Disable</el-radio>
                  </el-radio-group>
                  <label>Check Markers</label>
                  <el-button
                    size="mini"
                    class="micro"
                    type="danger"
                    plain
                    @click.stop="resetCheckMarkers('o')"
                  >
                    Clear Order Markers
                  </el-button>
                  <el-button
                    size="mini"
                    class="micro"
                    type="danger"
                    plain
                    @click.stop="resetCheckMarkers('r')"
                  >
                    Clear Route Markers
                  </el-button>
                  <label>LFD Background Color</label>
                  <ul class="circle">
                    <li>! Pink: Blank LFD with the pickup location</li>
                    <li>!! Red: Appt or Today is 1 day before LFD</li>
                  </ul>
                </div>
              </div>
              <el-button slot="reference" icon="el-icon-setting">
                Settings
              </el-button>
            </el-popover>
          </el-form-item>
          <el-form-item label="Search">
            <el-input
              clearable
              placeholder="Quick Table Filter"
              v-model.lazy="keyword"
              size="mini"
              style="width: 150px"
            >
              <i slot="prefix" class="el-input__icon el-icon-s-grid" />
            </el-input>
          </el-form-item>
          <el-form-item label="Terminals">
            <el-select
              v-model="terminals"
              multiple
              filterable
              clearable
              style="width: 360px"
            >
              <el-option
                v-for="name in options.terminals"
                :key="name"
                :label="name"
                :value="name"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="LFD">
            <el-radio-group v-model="lfdGrade">
              <el-radio-button label="none">All</el-radio-button>
              <el-radio-button label="a">!</el-radio-button>
              <el-radio-button label="aa">!!</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </div>
        <div>
          <el-form-item>
            <slot v-if="batchToEdit">
              <popup
                ref="batchEdit"
                className="font-bold no-underline mx-1 hidden"
                componentPath="pages/containers/replica"
                width="99%"
                height="100%"
                :pivot-y="0"
                :click-to-close="false"
                :options="batchOrderOptions"
              />
              <div class="batch-edit">
                <i class="el-icon-edit-outline px-1" />
                <el-dropdown v-if="!isEmptyData(importsToEdit)">
                  <span class="el-dropdown-link text-xs">
                    IM: {{ importsToEdit.length }}
                    <i class="el-icon-arrow-down el-icon--right" />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      @click.native="
                        batchEdit('ImportContainer', importsToEdit)
                      "
                    >
                      Batch Edit
                    </el-dropdown-item>
                    <el-dropdown-item
                      @click.native="copyBatchOrders(importsToEdit)"
                    >
                      Copy Numbers
                    </el-dropdown-item>
                    <el-dropdown-item
                      @click.native="clearBatchOrders(importsToEdit)"
                    >
                      Clear Selectors
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

                <el-dropdown v-if="!isEmptyData(exportsToEdit)">
                  <span class="el-dropdown-link text-xs">
                    EX: {{ exportsToEdit.length }}
                    <i class="el-icon-arrow-down el-icon--right" />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      @click.native="
                        batchEdit('ExportContainer', exportsToEdit)
                      "
                    >
                      Batch Edit
                    </el-dropdown-item>
                    <el-dropdown-item
                      @click.native="copyBatchOrders(exportsToEdit)"
                    >
                      Copy Numbers
                    </el-dropdown-item>
                    <el-dropdown-item
                      @click.native="clearBatchOrders(exportsToEdit)"
                    >
                      Clear Selectors
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown v-if="!isEmptyData(xtownsToEdit)">
                  <span class="el-dropdown-link text-xs">
                    XT: {{ xtownsToEdit.length }}
                    <i class="el-icon-arrow-down el-icon--right" />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      @click.native="batchEdit('XtownContainer', xtownsToEdit)"
                    >
                      Batch Edit
                    </el-dropdown-item>
                    <el-dropdown-item
                      @click.native="copyBatchOrders(xtownsToEdit)"
                    >
                      Copy Numbers
                    </el-dropdown-item>
                    <el-dropdown-item
                      @click.native="clearBatchOrders(xtownsToEdit)"
                    >
                      Clear Selectors
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </slot>
          </el-form-item>
          <el-form-item>
            <el-popover placement="bottom" width="200" trigger="hover">
              <ul class="stripe">
                <li class="stripe-item">
                  <el-checkbox v-model="upNotOut" border>
                    UP Not Yet Out-Gated
                  </el-checkbox>
                </li>
              </ul>
              <el-button-group slot="reference" style="margin-top: -1px">
                <el-button>Specific Terminals</el-button>
                <el-button
                  v-if="upNotOut"
                  type="danger"
                  size="mini"
                  class="narrow"
                  @click="upNotOut = false"
                  >Reset</el-button
                >
              </el-button-group>
            </el-popover>
          </el-form-item>
          <el-form-item>
            <el-dropdown>
              <el-button size="mini" icon="el-icon-more">
                More<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown" class="w-80">
                <el-dropdown-item @click.native="exportCsv('import')">
                  <div class="flex items-center justify-between">
                    Export to CSV
                    <div class="uppercase text-2xs">Import</div>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item @click.native="exportCsv('export')">
                  <div class="flex items-center justify-between">
                    Export to CSV
                    <div class="uppercase text-2xs">Export</div>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  @click.native="batchDelete()"
                  :disabled="!anySelected"
                >
                  <div class="flex items-center justify-between">
                    Batch Delete
                    <div class="uppercase text-2xs">
                      ({{ ordersSelected.length }} Selected)
                    </div>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  @click.native="batchTrace('all')"
                  :disabled="!isTraceable"
                >
                  <div class="flex items-center justify-between">
                    Batch Trace ETA/LFD
                    <div class="uppercase text-2xs">All</div>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  @click.native="batchTrace('selected')"
                  :disabled="!isTraceable || !anySelected"
                >
                  <div class="flex items-center justify-between">
                    Batch Trace ETA/LFD
                    <div class="uppercase text-2xs">
                      ({{ ordersSelected.length }} Selected)
                    </div>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  @click.native="sendRequest('all', 'pickup_lfd')"
                >
                  <div class="flex items-center justify-between">
                    Request Pickup No. & LFD
                    <div class="uppercase text-2xs">All</div>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  @click.native="sendRequest('selected', 'pickup_lfd')"
                  :disabled="!anySelected"
                >
                  <div class="flex items-center justify-between">
                    Request Pickup No. & LFD
                    <div class="uppercase text-2xs">
                      ({{ ordersSelected.length }} Selected)
                    </div>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
          <el-form-item v-if="source == 'default'">
            <e-fullscreen :selector="'.pre-alerts'" />
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div id="eta-chart" v-if="chartIsEable"></div>
    <el-tabs class="tb-tabs dense" v-if="withItems">
      <el-tab-pane>
        <span slot="label">
          <i class="el-icon-date"></i> Import
          <el-badge type="primary" :value="imports.length" />
        </span>
        <ContainerPreAlertTable
          ref="import"
          type="Import"
          :items="imports"
          :offset="tableOffset"
          @initColumnOptions="initColumnOptions"
          @loadChartData="loadChartData"
        />
      </el-tab-pane>
      <el-tab-pane label="Export">
        <span slot="label">
          <i class="el-icon-date"></i> Export
          <el-badge type="warning" :value="exports.length" />
        </span>
        <ContainerPreAlertTable
          ref="export"
          type="Export"
          :items="exports"
          :offset="tableOffset"
          @loadChartData="loadChartData"
        />
      </el-tab-pane>
      <el-tab-pane label="XTown">
        <span slot="label">
          <i class="el-icon-date"></i> XTown
          <el-badge type="danger" :value="xtowns.length" />
        </span>
        <ContainerPreAlertTable
          ref="xtown"
          type="Xtown"
          :items="xtowns"
          :offset="tableOffset"
          @loadChartData="loadChartData"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import api from "@/default/utils/api";
import ContainerPreAlertTable from "@/default/pages/containers/pre_alert/table.vue";

export default {
  name: "ContainerPreAlert",
  mixins: [api],
  components: {
    ContainerPreAlertTable,
  },
  props: {
    mark: {
      type: String,
      required: true,
    },
    hubId: {
      type: Number,
      required: true,
    },
    offsets: {
      type: Array,
      default: () => {
        return [535, 290];
      },
    },
    source: {
      type: String,
      default: "default",
    },
  },
  data() {
    return {
      count: 0,
      items: [],
      chart: null,
      chartData: {},
      reloadChart: false,
      keyword: "",
      terminals: [],
      lfdGrade: "none",
      columnOptions: [],
      chartEnable: null,
      options: {
        terminals: [],
      },
      upNotOut: false,
      fuseOptions: {
        shouldSort: true,
        threshold: 0.25,
        location: 0,
        distance: 50,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: [
          "id",
          "abbrev_type",
          "container_no",
          "chassis_no",
          "ssline_bl_no",
          "ctype",
          "terminals.name",
          "ssline.name",
          "customer.name",
          "warehouses.name",
          "warehouses.city",
          "public_comment",
        ],
      },
      receivedData: {},
      batchOrderOptions: {},
    };
  },
  mounted() {
    this.initByStorage();
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("container-colorify", this.colorify);
    window.ContainerPreAlert = { receive: this.receive };
  },
  created() {
    this.loadData();
  },
  beforeDestroy() {
    this.items = [];
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("container-colorify", this.colorify);
  },
  watch: {
    upNotOut(nv, ov) {
      if (nv != ov) {
        this.terminals = [];
        this.options.terminals = [];
        this.loadItems();
      }
    },
    receivedData(nv, ov) {
      if (JSON.stringify(nv) != JSON.stringify(ov)) {
        switch (nv.mark) {
          case "delete":
            this.consumeDelete();
            break;
          default:
            this.consumeDefault();
            break;
        }
      }
    },
    items(nv, ov) {
      this.$emit("updateCount", { mark: this.mark, count: nv.length });
    },
    chartIsEable(nv, ov) {
      if (nv) {
        this.loadChartData();
      } else {
        this.chart.destroy();
        this.chartData = [];
      }
    },
    chartData(nv, ov) {
      this.$nextTick(function () {
        this.drawCharts();
      });
    },
    reloadChart(nv, ov) {
      if (nv) {
        this.loadChartData();
      }
    },
  },
  computed: {
    chartIsEable() {
      return this.chartEnable == "enable";
    },
    withItems() {
      return this.items.length > 0;
    },
    filteredItems() {
      let items = this.items;
      if (this.lfdGrade != "none") {
        items = items.filter((o) => o.lfd_grade == this.lfdGrade);
      }
      if (this.terminals.length > 0) {
        items = items.filter((o) => {
          const names = o.terminals.map((t) => t.name);
          return this.terminals.some((t) => names.includes(t));
        });
      }
      if (this.keyword.length >= 3)
        items = this.$search(this.keyword, items, this.fuseOptions).map(
          (o) => o.item,
        );
      return items;
    },
    groupFilteredItems() {
      return this._.groupBy(this.filteredItems, "type");
    },
    imports() {
      return this.groupFilteredItems["ImportContainer"] || [];
    },
    exports() {
      return this.groupFilteredItems["ExportContainer"] || [];
    },
    xtowns() {
      return this.groupFilteredItems["XtownContainer"] || [];
    },
    isTraceable() {
      return (
        this.$store.envs.trace &&
        (!this.isEmptyData(this.imports) || !this.isEmptyData(this.xtowns))
      );
    },
    ordersSelected() {
      return this.filteredItems.filter((o) => o.selected);
    },
    anySelected() {
      return this.ordersSelected.length > 0;
    },
    selectedImports() {
      return this.imports.filter((o) => o.selected);
    },
    selectedExports() {
      return this.exports.filter((o) => o.selected);
    },
    selectedXtowns() {
      return this.xtowns.filter((o) => o.selected);
    },
    tableOffset() {
      return this.chartIsEable ? this.offsets[0] : this.offsets[1];
    },
    importsToEdit() {
      return this.imports.filter((o) => o.editing);
    },
    exportsToEdit() {
      return this.exports.filter((o) => o.editing);
    },
    xtownsToEdit() {
      return this.xtowns.filter((o) => o.editing);
    },
    batchToEdit() {
      return (
        this.importsToEdit.length > 0 ||
        this.exportsToEdit.length > 0 ||
        this.xtownsToEdit.length > 0
      );
    },
  },
  methods: {
    initColumnOptions() {
      this.columnOptions = this.getTableColumns("pre-alert");
    },
    resetColumns() {
      this.$actions.updateTableColumns({ ["pre-alert"]: [] });
      this.$refs.import.initCachedColumns();
    },
    toggleColumn(checked, name) {
      this.updateTableColumn("pre-alert", name, { visbile: checked });
    },
    moveColumn() {
      this.columnOptions.forEach((column, index) => {
        column.order = index + 1;
      });
      this.$actions.updateTableColumns({ ["pre-alert"]: this.columnOptions });
    },
    initByStorage() {
      this.chartEnable = this.getSettings("chartEnable", "disable");
    },
    changeChartEnable() {
      this.updateSettings({ chartEnable: this.chartEnable });
    },
    loadData() {
      this.items = [];
      this.loadItems();
      this.loadChartData();
    },
    async loadItems() {
      let params = {};
      if (this.upNotOut) params.scoped = "up_not_outgated";
      try {
        const response = await this.$http.get(
          "/api/v1/containers/pre_alerts?terminals=only",
          { params },
        );
        const data = response.data;
        this.count = data.containers;
        this.options.terminals = data.terminals;
        const url = "/api/v1/containers/pre_alerts";
        const perPage = 1000;
        const promises = new Array(Math.ceil(this.count / perPage))
          .fill(0)
          .map(async (o, index) => {
            const pageResponse = await this.$http.get(
              `${url}?page=${index + 1}&per_page=${perPage}`,
              { params },
            );
            let newRecords = this.processItems(pageResponse.data);
            this.items = this.items.concat(newRecords);
          });
        await Promise.all(promises);
      } catch (err) {
        if (err.response?.data?.errors) {
          this.$message({
            message: err.response.data.errors,
            type: "error",
          });
        }
      }
    },
    processItems(items) {
      return items.map((item) => this.processItem(item));
    },
    processItem(item) {
      return item;
    },
    async loadChartData() {
      if (this.chartIsEable) {
        this.chartData = {};
        try {
          const response = await this.$http.get(
            `/api/v1/containers/pre_alerts?chart=only`,
          );
          this.chartData = response.data;
          this.reloadChart = false;
        } catch (err) {}
      }
    },
    drawCharts() {
      if (!this.isEmptyData(this.chartData.import)) {
        this.chart = PreAlert.chart("eta-chart", this.chartData.import);
      }
    },
    receive(data) {
      if (data.hub_id != this.hubId) return;
      if (!this.agentScoped(data.agent_id)) return;
      this.receivedData = data;
    },
    colorify(event) {
      const { id, color } = event.detail;
      const item = this.items.find((item) => item.id === id);
      if (item) this.$set(item, "color", color);
    },
    consumeDelete() {
      let index = this.findCurrentIndex();
      if (index >= 0) {
        // console.log(`Sync Pre-Alert Delete: ${index}`);
        this.items.splice(index, 1); // delete
      }
    },
    consumeDefault() {
      let index = this.findCurrentIndex();
      this.processItem(this.receivedData);
      const record = JSON.parse(JSON.stringify(this.receivedData));
      if (index >= 0) {
        // console.log(`Sync Pre-Alert Update: ${this.receivedData.id}`);
        const oriData = this.items[index];
        record.editing = oriData["editing"];
        this.items.splice(index, 1, record); // update
        this.reloadChart = oriData.eta != record.eta;
      } else {
        // console.log(`Sync Pre-Alert Insert: ${this.receivedData.id}`);
        this.items.push(this.receivedData); // insert
        this.reloadChart = true;
      }
    },
    findCurrentIndex() {
      return this.items.findIndex((o) => o.id == this.receivedData.id);
    },
    handleResize() {
      this.drawCharts();
    },
    exportCsv(type) {
      const ids = (type == "import" ? this.imports : this.exports).map(
        (o) => o.id,
      );
      this.postDownload("/api/v1/containers/pre_alerts.csv", { type, ids });
    },
    batchEdit(type, orders) {
      const ids = orders.map((o) => o.id);
      this.batchOrderOptions = { mode: "edit", master: { type }, ids };
      this.$refs.batchEdit.open();
    },
    copyBatchOrders(orders) {
      const numbers = orders.map((o) => o.container_no).join("\n");
      this.$copyText(numbers).then(
        (e) => {
          this.$message({
            message: "Container numbers are copied to clipboard",
            type: "success",
          });
        },
        (e) => {},
      );
    },
    clearBatchOrders(orders) {
      orders.forEach((o) => {
        this.$set(o, "editing", false);
      });
    },
    async batchDelete() {
      try {
        await this.$confirm(
          "Are you sure to delete the selected orders?",
          "Confirmation",
          {
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            type: "warning",
          },
        );

        const ids = this.ordersSelected.map((o) => o.id);
        try {
          await this.$http.patch("/api/v1/containers/delete", { ids });
        } catch (err) {
          const errors = err.response.data.errors;
          let list = "";
          for (const id in errors) {
            list += `<li>${id}: ${errors[id]}</li>`;
          }
          list = `<ul class="circle red">${list}</ul>`;
          this.$alert(list, "Undeletable Order(s)", {
            dangerouslyUseHTMLString: true,
            showConfirmButton: false,
          });
        }
      } catch (err) {
        this.$message({
          message: "The action to batch delete is cancelled.",
          type: "info",
        });
      }
    },
    async batchTrace(scope) {
      try {
        let orders, message;
        if (scope == "all") {
          orders = this.imports.concat(this.xtowns);
          message = `Are you sure to trace ETA/LFD? (${this.imports.length} imports, ${this.xtowns.length} xtowns)?`;
        } else {
          orders = this.selectedImports.concat(this.selectedXtowns);
          message = `Are you sure to trace ETA/LFD? (${this.selectedImports.length} imports, ${this.selectedXtowns.length} xtowns)?`;
        }
        await this.$confirm(message);
        const response = await this.$http2.post("/api/v1/traces/batch", {
          ids: orders.map((o) => o.id),
        });
        this.$message({
          message: response.data.message,
          type: "success",
        });
      } catch (err) {
        if (err !== "cancel") {
          console.error(err);
        }
      }
    },
    async sendRequest(scope, category) {
      try {
        let ids, message;
        if (scope == "all") {
          message = `Are you sure to email clients to request Pickup No. or LFD? (Only orders with the ETA today or tomorrow)`;
        } else {
          ids = this.ordersSelected.map((o) => o.id);
          message = `Are you sure to email clients to request Pickup No. or LFD? (Only selected orders with the ETA today or tomorrow)`;
        }
        await this.$confirm(message, "Confirmation", {
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          type: "warning",
        });

        const response = await this.$http.post("/api/v1/containers/email", {
          category,
          ids,
        });
        this.$message({
          message: response.data.message,
          type: "success",
        });
      } catch (err) {
        if (err !== "cancel") {
          this.$message({
            message: err.response.data.errors,
            type: "error",
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pre-alerts {
  #eta-chart {
    @apply border mb-2 p-1;
  }

  .batch-edit {
    @apply empty:hidden border bg-white h-7 px-1 rounded flex items-center divide-x;
    & > div {
      @apply px-1;
    }
  }
}

.stripe {
  .stripe-item {
    @apply cursor-pointer;

    label {
      @apply box-border w-full mr-0 #{!important};
    }
  }
}
</style>
